import React, { Component } from "react";
import Header from './Header'
import {GetUser, RemoveUser} from '../util/Helper';
import { useAuth0 } from "@auth0/auth0-react";
import ImageOrInitial from "../components/ImageOrInitial";
const Users = () => {
  const { logout } = useAuth0();
  const account = GetUser();

  function logoutUser(){
    RemoveUser();
    logout({
      returnTo:window.location.hostname.indexOf('localhost') > -1 ? 'http://localhost:3000/' : 'https://dev-binderdrop.azurewebsites.net/'
    })
  }

  return (
    <div>
    <Header title="Users"/>
    {account &&
     <div className="card fullTable">
          <a key={"account_"+account.name} className="tableRow" href={"/user"}>
           <ImageOrInitial image={account.imageUrl} className="searchItemLogo" name={account.name} />
           <span  className="searchItemName">{account.name}</span>
           <span  className="searchItemSecondary">{account.email} </span>
         </a>
     
     </div>
    }
  </div>
  
  ) 
}

 
export default Users;
